export enum ScheduleStatusEnum {
  Pending = 1,
  Active = 2,
  Finished = 3,
  Cancelled = 4,
}
